import { render } from "./Categories.vue?vue&type=template&id=a9cbc6f2&scoped=true&ts=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"

import "./Categories.vue?vue&type=style&index=0&id=a9cbc6f2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cbc6f2"]])

export default __exports__